import { Dependencies, DependenciesFactory, FileContent, FileContentFactory } from ".."

export interface CreatePerk {
    activeFrom: string
    activeTo: string
    isDraft: boolean
    isActive: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    image: FileContent
    contact?: {
        email: string
        phoneNumber: string
    }
    link?: string
    categoryIds: string[]
    locationIds: string[]
    dependencies: Dependencies | null
}

export class CreatePerkFactory {
    static create(): CreatePerk {
        return {
            activeFrom: "",
            activeTo: "",
            isDraft: false,
            isActive: false,
            names: {
                hr: "",
                en: "",
            },
            descriptions: {
                hr: "",
                en: "",
            },
            image: FileContentFactory.create(),
            contact: {
                email: "",
                phoneNumber: "",
            },
            link: "",
            categoryIds: [],
            locationIds: [],
            dependencies: DependenciesFactory.create(),
        }
    }
}
